import { HTMLAttributeAnchorTarget } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { LinkWithIconTruncatable } from "src/components/common/link-with-icon";
import { IconUnderlying } from "src/components/icons";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface IUserReactionBarLabelProps {
    label: string;
    underlyingIsin?: string | null;
    underlyingName?: string | null;
    underlyingLinkTarget?: HTMLAttributeAnchorTarget;
    onLinkClick?: (url: string) => void;
}

export const UserReactionBarLabel = ({
    onLinkClick,
    label,
    underlyingIsin,
    underlyingName,
    underlyingLinkTarget = "_blank",
}: IUserReactionBarLabelProps) => {
    const linkBuilder = useLinkBuilder();
    const url = linkBuilder.buildUnderlyingLink(underlyingIsin ?? "");

    return (
        <Flex gap={1}>
            <Text whiteSpace="nowrap">{label}</Text>
            {underlyingIsin && underlyingName && (
                <LinkWithIconTruncatable
                    icon={IconUnderlying}
                    url={url}
                    textProps={{ wordBreak: "break-all" }}
                    linkProps={{ target: underlyingLinkTarget, onClick: () => onLinkClick?.(url) }}
                >
                    {underlyingName}
                </LinkWithIconTruncatable>
            )}
        </Flex>
    );
};
